/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU8Decoder,
  getU8Encoder,
  transformEncoder,
  type AccountMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import { COMPUTE_BUDGET_PROGRAM_ADDRESS } from '../programs';

export const SET_LOADED_ACCOUNTS_DATA_SIZE_LIMIT_DISCRIMINATOR = 4;

export function getSetLoadedAccountsDataSizeLimitDiscriminatorBytes() {
  return getU8Encoder().encode(
    SET_LOADED_ACCOUNTS_DATA_SIZE_LIMIT_DISCRIMINATOR
  );
}

export type SetLoadedAccountsDataSizeLimitInstruction<
  TProgram extends string = typeof COMPUTE_BUDGET_PROGRAM_ADDRESS,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<TRemainingAccounts>;

export type SetLoadedAccountsDataSizeLimitInstructionData = {
  discriminator: number;
  accountDataSizeLimit: number;
};

export type SetLoadedAccountsDataSizeLimitInstructionDataArgs = {
  accountDataSizeLimit: number;
};

export function getSetLoadedAccountsDataSizeLimitInstructionDataEncoder(): FixedSizeEncoder<SetLoadedAccountsDataSizeLimitInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', getU8Encoder()],
      ['accountDataSizeLimit', getU32Encoder()],
    ]),
    (value) => ({
      ...value,
      discriminator: SET_LOADED_ACCOUNTS_DATA_SIZE_LIMIT_DISCRIMINATOR,
    })
  );
}

export function getSetLoadedAccountsDataSizeLimitInstructionDataDecoder(): FixedSizeDecoder<SetLoadedAccountsDataSizeLimitInstructionData> {
  return getStructDecoder([
    ['discriminator', getU8Decoder()],
    ['accountDataSizeLimit', getU32Decoder()],
  ]);
}

export function getSetLoadedAccountsDataSizeLimitInstructionDataCodec(): FixedSizeCodec<
  SetLoadedAccountsDataSizeLimitInstructionDataArgs,
  SetLoadedAccountsDataSizeLimitInstructionData
> {
  return combineCodec(
    getSetLoadedAccountsDataSizeLimitInstructionDataEncoder(),
    getSetLoadedAccountsDataSizeLimitInstructionDataDecoder()
  );
}

export type SetLoadedAccountsDataSizeLimitInput = {
  accountDataSizeLimit: SetLoadedAccountsDataSizeLimitInstructionDataArgs['accountDataSizeLimit'];
};

export function getSetLoadedAccountsDataSizeLimitInstruction<
  TProgramAddress extends Address = typeof COMPUTE_BUDGET_PROGRAM_ADDRESS,
>(
  input: SetLoadedAccountsDataSizeLimitInput,
  config?: { programAddress?: TProgramAddress }
): SetLoadedAccountsDataSizeLimitInstruction<TProgramAddress> {
  // Program address.
  const programAddress =
    config?.programAddress ?? COMPUTE_BUDGET_PROGRAM_ADDRESS;

  // Original args.
  const args = { ...input };

  return Object.freeze({
    data: getSetLoadedAccountsDataSizeLimitInstructionDataEncoder().encode(
      args as SetLoadedAccountsDataSizeLimitInstructionDataArgs
    ),
    programAddress,
  } as SetLoadedAccountsDataSizeLimitInstruction<TProgramAddress>);
}

export type ParsedSetLoadedAccountsDataSizeLimitInstruction<
  TProgram extends string = typeof COMPUTE_BUDGET_PROGRAM_ADDRESS,
> = {
  programAddress: Address<TProgram>;
  data: SetLoadedAccountsDataSizeLimitInstructionData;
};

export function parseSetLoadedAccountsDataSizeLimitInstruction<
  TProgram extends string,
>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>
): ParsedSetLoadedAccountsDataSizeLimitInstruction<TProgram> {
  return {
    programAddress: instruction.programAddress,
    data: getSetLoadedAccountsDataSizeLimitInstructionDataDecoder().decode(
      instruction.data
    ),
  };
}
